// state
import { Link } from "react-router-dom";

// constants
import { FaFacebook, FaInstagram, FaLinkedin, FaTwitter } from "react-icons/fa";
import img from "../constant";

type ItemType = {
  name: string;
  key: number;
  link: string;
};

const service: ItemType[] = [
  { name: "Trust Center", key: 1, link: "/trust-center" },
  { name: "Data Encryption", key: 2, link: "/data-encryption" },
];

const about: ItemType[] = [
  // { name: "Origin", key: 1, link: "/origin" },
  { name: "About", key: 1, link: "https://25thandstaffing.com/origin" },
  { name: "Contact", key: 2, link: "https://25thandstaffing.com/talk-to-us" },
];
const legal: ItemType[] = [
  // { name: "Origin", key: 1, link: "/origin" },
  { name: "Terms of Service", key: 2, link: "/terms" },
  { name: "Privacy Policy", key: 1, link: "/policy" },
  { name: "Data Processing Addendum", key: 4, link: "/dpa" },
  { name: "Cookie Policy", key: 3, link: "/cookie-policy" },
];

const FooterComponent = () => {
  return (
    <footer className="font-abel">
      <div className="py-4 px-5 flex justify-between md:px-[80px] flex-wrap md:py-10 md:flex md:justify-between text-[white] bg-[#000E43]">
        <div className="my-9 text-[white]">
          <div className="mb-4 ">
            <h2 className="font-medium text-[16px]">CONTACT</h2>
          </div>
          <div className="mb-[0.3rem]">
            <a href="tel:+2349133779831" className="md:text-[16px] text-[14px]">
              +234 913 377 9831
            </a>
          </div>
          <div className="mb-[0.3rem]">
            <a href="tel:+7136365773" className="md:text-[16px] text-[14px]">
              +713 636 5773
            </a>
          </div>
          <div className="mb-[0.3rem]">
            <a
              href="mailto:info@25thmail.com"
              className="md:text-[16px] text-[14px]"
            >
              info@25thmail.com
            </a>
          </div>
          <div className="mb-[0.3rem]">
            <p className="md:text-[16px] text-[14px]">
              NGN: 9th Floor, 2, Idowu Taylor Street, Victoria Island, Lagos
            </p>
          </div>
          <div>
            <p className="md:text-[16px] text-[14px]">
              USA: 3527 Mount Diablo Blvd, Lafayette, CA 94549, USA
            </p>
          </div>
        </div>

        <div className="my-9">
          <div className="mb-4">
            <h2 className="font-medium text-[16px]">SECURITY & TRUST</h2>
          </div>
          <ul>
            {service?.map((item) => (
              <li key={item.key} className="mb-2 md:text-[16px] text-[14px]">
                <Link to={item.link} target="_blank" rel="noopener noreferrer">
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:text-left my-9">
          <h2 className="font-medium text-[16px] mb-4">COMPANY</h2>
          <ul>
            {about?.map((item) => (
              <li key={item.key} className="mb-2 md:text-[16px] text-[14px]">
                <Link to={item.link} target="_blank" rel="noopener noreferrer">
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:text-left my-9">
          <h2 className="font-medium text-[16px] mb-4">LEGAL</h2>
          <ul>
            {legal?.map((item) => (
              <li key={item.key} className="mb-2 md:text-[16px] text-[14px]">
                <Link to={item.link} target="_blank" rel="noopener noreferrer">
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="border-[white] border-l-2 md:pl-4 pl-6 my-9">
          <div className="md:h-[130px] md:relative">
            <img
              src={img.logoWhite}
              alt="25th and Staffing Badge"
              className="h-[80px] md:h-[130px] mb-3 md:absolute md:top-[-20px]"
            />
          </div>
          <div className="flex flex-wrap justify-start md:justify-center items-center">
            <div className="p-1 border mx-1 rounded-full border-[white] cursor-pointer hover:border-[#243677]">
              <a
                href="https://mobile.twitter.com/25thstaffing"
                target="__blank"
                rel="noreferrer"
              >
                <FaTwitter color="#fff" fontSize="1.0rem" />
              </a>
            </div>
            <div className="p-1 border mx-1 rounded-full border-[#ffffff] cursor-pointer hover:border-[#243677]">
              <a
                href="https://m.facebook.com/people/25th-and-Staffing/100065267672006/"
                target="_blank"
                rel="noreferrer"
              >
                <FaFacebook color="#ffffff" fontSize="1.0rem" />
              </a>
            </div>
            <div className="p-1 border mx-1 rounded-full border-[#ffffff] cursor-pointer hover:border-[#243677]">
              <a
                href="https://www.instagram.com/25thandstaffing_official"
                target="__blank"
                rel="noreferrer"
              >
                <FaInstagram color="#ffffff" fontSize="1.0rem" />
              </a>
            </div>
            <div className="p-1 border mx-1 rounded-full border-[#ffffff] cursor-pointer hover:border-[#243677]">
              <a
                href="https://ng.linkedin.com/company/25thandstaffing-com"
                target="__blank"
                rel="noreferrer"
              >
                <FaLinkedin color="#ffffff" fontSize="1.0rem" />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full text-sm md:text-[16px] flex items-center justify-center px-2 py-3 md:px-4 md:py-5 text-[#272727] text-center">
        &#169; 25th &amp; Staffing {new Date().getFullYear()}.&nbsp;
        <Link to="/policy" className="text-[#243677] cursor-pointer">
          Privacy Policy
        </Link>{" "}
        &nbsp;|&nbsp;{" "}
        <Link to="/terms" className="text-[#243677] cursor-pointer">
          Terms and Conditions
        </Link>
        {/* &nbsp;|&nbsp;{" "}
        <Link to="/services/terms" className="text-[#243677] cursor-pointer">
          Rebate T&C
        </Link> */}
      </div>
    </footer>
  );
};

export default FooterComponent;
